import { Box, makeStyles } from '@material-ui/core';
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';
import DescriptionComponent from '../../components/DescriptionComponent';
import HtmlComponent from '../../components/HtmlComponent';

const useStyles = makeStyles((theme) => ({
	houseLink: {
		textDecoration: 'none',
	},
	btnBox: {
		marginTop: theme.spacing(8),
		[theme.breakpoints.down('sm')]: {
			marginTop: theme.spacing(2),
		},
	},
	link: {
		textDecoration: 'none',
		marginRight: 20,
		[theme.breakpoints.down('sm')]: {
			marginRight: 0,
			marginBottom: 20,
		},
	}
}))

const HousePage = (props) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const history = useHistory();
	const handleBack = useCallback(() => {
		history.goBack();
	}, [history])

	return (
		<DescriptionComponent title={t('house_page.service_title')} custom hiddenBtn>
			<HtmlComponent text={t('house_page.content')} />
			<Box className={classes.btnBox}>
				<ButtonComponent onClick={handleBack}>
					{t('buttons.back')}
				</ButtonComponent>
			</Box>
		</DescriptionComponent>
	)
}


export default HousePage;